import React from 'react';
import PropTypes from 'prop-types';

const NewContainerButton = props => (
  <div className="newContainerButton">
    <button
      className="btn btn-tertiary outline"
      type="submit"
      onClick={() => props.addContainer(props.selectedEstimate)}
    >
      Add New Room
    </button>
  </div>
);

NewContainerButton.propTypes = {
  addContainer: PropTypes.func.isRequired,
  selectedEstimate: PropTypes.string.isRequired,
};

export default NewContainerButton;
